/*
 * Call to Order button (snippets/call-to-order.liquid), on 0.00-priced products.
 *
 * Mobile / touch: the anchor is a plain tel: link, so a tap hands off to the dialer.
 * Desktop: there is no dialer, so the first click reveals the number in the label
 * instead of firing a tel: handler the machine probably cannot service. A second
 * click is left alone, so anyone running a softphone can still place the call.
 *
 * Listener is delegated on document, so it also covers buttons injected later by
 * configurator-loader.js (that markup arrives via innerHTML, which would not run an
 * inline script).
 */
(function () {
  if (window.__devonCallToOrderBound) return;
  window.__devonCallToOrderBound = true;

  var canDial = window.matchMedia('(hover: none), (pointer: coarse)');

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-devon-call-to-order]');
    if (!link) return;

    // Touch devices, and any second click once the number is on screen: let the
    // tel: link do its normal thing.
    if (canDial.matches || link.dataset.revealed === 'true') return;

    event.preventDefault();
    link.dataset.revealed = 'true';

    var label = link.querySelector('[data-devon-call-to-order-label]');
    if (label && link.dataset.phone) label.textContent = link.dataset.phone;
  });
})();
